import { last } from 'ramda';
import { isFunction } from 'ramda-adjunct';

const isPerformanceMethodSupported = (method) => window.performance && isFunction(window.performance[method]);

export const now: Performance['now'] = () => (isPerformanceMethodSupported('now') ? performance.now() : 0);
export const mark: Performance['mark'] = (name) =>
  isPerformanceMethodSupported('mark') ? performance.mark(name) : undefined;
export const measure: Performance['measure'] = (...args) =>
  isPerformanceMethodSupported('measure') ? performance.measure(...args) : undefined;
export const getEntriesByName: Performance['getEntriesByName'] = (...args) =>
  isPerformanceMethodSupported('getEntriesByName') ? performance.getEntriesByName(...args) : [];
export const clearMarks: Performance['clearMarks'] = () =>
  isPerformanceMethodSupported('clearMarks') ? performance.clearMarks() : undefined;
export const clearMeasures: Performance['clearMeasures'] = () =>
  isPerformanceMethodSupported('clearMeasures') ? performance.clearMeasures() : undefined;

export const getDurationBetweenMarks = (
  startMark: PerformanceEntry['name'],
  endMark: PerformanceEntry['name'],
): PerformanceEntry['duration'] => {
  if (!isPerformanceMethodSupported('measure')) {
    return 0;
  }

  const markName = `${startMark}-${endMark}`;
  measure(markName, startMark, endMark);

  const lastEntry = last(getEntriesByName(markName));

  return (lastEntry && lastEntry.duration) || 0; // propOr(0, 'duration') doesn't work well with PerformanceEntry
};
